<template>
  <div>
    <div class="content-header">
      <div class="left">
         <span class="title">优惠券</span>
      </div>
      <div class="right">
        <Button type="primary" @click="openModal({
          name: '',
          over_day: 1,
          money: 1
        })">新增优惠券</Button>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data" :loading="tableLoading"/>
    </div>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" show-elevator show-sizer show-total/>
    </div>
    <Modal v-model="visible" title="优惠券">
      <Form ref="formInline" :model="current" :rules="rule" :label-width="100" inline>
        <FormItem prop="name" label="名称:">
          <Input v-model="current.name" style="width:120px" placeholder="优惠券名称"/>
        </FormItem>
        <FormItem prop="describe" label="描述:">
          <Input v-model="current.describe" style="width:120px" placeholder="优惠券描述"/>
        </FormItem>
        <FormItem prop="over_day" label="过期天数:">
          <InputNumber :min="1" style="width:120px" v-model="current.over_day"></InputNumber>
        </FormItem>
        <FormItem prop="money" label="金额:">
          <InputNumber :active-change="false" :precision="2" :min="0.1" :max="100" style="width:120px"  v-model="current.money"></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button size="large" @click="visible = false;">取消</Button>
        <Button type="primary" size="large" @click="modalOk" :loading="modalLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      data: [],
      page: {
        p: 0,
        l: 10
      },
      total: 0,
      columns: [
        { title: '编号', key: 'id' },
        { title: '优惠名称', key: 'name' },
        { title: '优惠描述', key: 'describe' },
        { title: '金额', key: 'money' },
        { title: '过期天数', key: 'over_day' },
        { title: '创建时间',
          key: 'create_time',
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          } },
        { title: '操作',
          key: 'operate',
          render: (h, data) => {
            return h('div', {}, [
              h('Button', { props: { size: 'small', type: data.row.is_del ? 'success' : 'error' },
                on: {
                  click: () => {
                    this.delCoupon(data.row.id, data.row.is_del)
                  }
                } }, data.row.is_del ? '恢复' : '删除'),
              h('Button', { props: { size: 'small', type: 'warning' },
                style: { marginLeft: '5px' },
                on: {
                  click: () => {
                    this.openModal(JSON.parse(JSON.stringify(data.row)))
                  }
                } }, '修改')
            ])
          } }
      ],
      tableLoading: false,
      modalLoading: false,
      visible: false,
      current: {},
      rule: {
        over_day: [{ validator: (rule, value, callback) => {
          if (parseInt(value) == value && parseInt(value) > 0) {
            callback()
          } else {
            callback(new Error('请输入大于零正整数'))
          }
        },
        required: true,
        trigger: 'blur' }]
      }
    }
  },
  methods: {
    delCoupon (id, is_del) {
      this.saveCoupon({ id: id, is_del: is_del ? 0 : 1 }).then(res => {
        this.data.map(item => {
          if (item.id === id) {
            item.is_del = is_del ? 0 : 1
          }
        })
      })
    },
    openModal (data) {
      this.$refs.formInline.resetFields()
      this.visible = true
      this.current = data
    },
    getData () {
      this.tableLoading = true
      this.getCoupon(this.page).then(res => {
        this.data = res.data
        this.total = res.total
        this.tableLoading = false
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    modalOk () {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          this.modalLoading = true
          let data = this.current
          delete data._index
          delete data._rowKey
          this.saveCoupon(data).then(res => {
            this.modalLoading = false
            this.visible = false
            this.getData()
          })
        }
      })
    },
    ...mapActions(['getCoupon', 'saveCoupon'])
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({

  })
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
